import React, {PureComponent, CSSProperties} from 'react'
import {inject} from 'mobx-react'
import cxs from 'cxs/component'
import Store from 'Store'
import Theme from 'Theme'
import {t} from 'helpers/i18n'
import History from 'helpers/History'
import {sections, sectionsNavBar} from 'scenes/Main'
import UserLogout from 'modules/Users/containers/UserLogout'
import {Button, Icon} from 'elements'
import {Link} from 'react-router-dom'

interface Props {
  store?: Store
}

@inject('store')
class NavBarDesktop extends PureComponent<Props, object> {
  handleLink = activePath => () => {
    console.log('NavBarDesktop - handleLink', activePath)
    this.setState({activePath})
    History.push(activePath)
  }

  render() {
    return (
      <Wrapper>
        {sections(this.props.store!.users.user).map(section => (
          <DropDown key={section.name}>
            <StyledButton onClick={() => {}}>{t(section.name)}</StyledButton>
            <DropDownContent>
              {section.links.map(link => (
                <DropDownLink
                  onClick={this.handleLink(link.path)}
                  key={link.name}>
                  {t(link.name)}
                </DropDownLink>
              ))}
            </DropDownContent>
          </DropDown>
        ))}
        <UserLogout />
      </Wrapper>
    )
  }
}

export default NavBarDesktop

const Wrapper = cxs('div')({
  /*float: 'right',
  position: 'relative',
  top: '50%',
  transform: 'translateY(-50%)',*/
  zIndex: 1,
  /*background: 'yellow',*/
} as CSSProperties)

const DropDown = cxs('div')({
  float: 'left',
  overflow: 'hidden',
  ':hover div': {
    display: 'block'
  },
  ':hover > button': {
    color: Theme.color.primary
  }
} as CSSProperties)

const StyledButton = cxs(Button)({} as CSSProperties)

const DropDownContent = cxs('div')({
  display: 'none',
  position: 'absolute',
  backgroundColor: Theme.color.background,
  border: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  borderTopWidth: 0,
  boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2)',
} as CSSProperties)

const DropDownLink = cxs(Button)({
  display: 'block',
  width: '100%',
  float: 'none',
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  ':last-child': {
    borderWidth: 0
  },
  ':hover': {
    color: Theme.color.primary
  }
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavBarDesktop.tsx